import React from 'react';
import { Sparkles } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

/**
 * DemoModeBadge — pill rendered whenever the currently signed-in user is
 * a seeded demo account (user.is_demo === true). Makes it obvious during
 * screen recordings and sales pitches that the data on screen is fake.
 *
 * Renders nothing for real users, anonymous visitors, or while auth is
 * still loading.
 */
const DemoModeBadge = ({ className = '' }) => {
  const { user } = useAuth();
  if (!user || !user.is_demo) return null;

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-[#C9A27A]/15 border border-[#C9A27A]/50 text-[#8A6A3D] text-[10px] font-semibold uppercase tracking-[0.14em] ${className}`}
      title="You are signed in as a demo account. All data shown is fake and safe to share publicly."
      data-testid="demo-mode-badge"
    >
      <Sparkles className="w-3 h-3" />
      Demo Mode
    </span>
  );
};

export default DemoModeBadge;
